import React from 'react';
import { useTranslation } from 'react-i18next';

import './Team.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import imgOne from '../../assets/about/team/1.webp';
import imgTwo from '../../assets/about/team/2.webp';
import imgThree from '../../assets/about/team/3.webp';

const Team = () => {
    const { t } = useTranslation();

    const teams = [
        {
            img: imgOne,
            name: t('team.members.tatjana.name'),
            title: t('team.members.tatjana.description')
        },
        {
            img: imgTwo,
            name: t('team.members.sergey.name'),
            title: t('team.members.sergey.description')
        },
        {
            img: imgThree,
            name: t('team.members.alfiya.name'),
            title: t('team.members.alfiya.description')
        }
    ];

    return (
        <section
            className="team-section pt-100"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <div className="row">

                    <div className="col-lg-7">
                        <SectionTitle
                            subTitle={t('team.subTitle')}
                            title={t('team.title')}
                        />
                    </div>

                    <div className="col-lg-5">
                        <p className="pt-5">
                            {t('team.description')}
                        </p>
                    </div>

                </div>

                <div className="row justify-content-center">

                    {teams.map((team) => (
                        <div
                            className="col-lg-4 col-md-6 col-sm-6 d-flex justify-content-center"
                            key={team.name}
                        >
                            <div className="team-card">

                                <div className="team-img">
                                    <img
                                        src={team.img}
                                        alt={team.name}
                                    />
                                </div>

                                <h3>{team.name}</h3>

                                <p>{team.title}</p>

                            </div>
                        </div>
                    ))}

                </div>

            </div>
        </section>
    );
};

export default Team;